import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import { useSelector } from "react-redux";
import { CancelBtn } from "../Styles/InputStyles";

const userTypeLabels = {
  3: "Registrar",
  4: "Asst Registrar",
  8: "BMT (Assistant) Registrar",
};

const ViewRemarksModel = ({ setOpenViewRemarksModel, selectedItem }) => {
  // console.log(selectedItem);
  const user = useSelector((state) => state.UserReducer.user);

  return (
    <Model width={"w-11/12 max-w-2xl"} setOpenModel={setOpenViewRemarksModel}>
      <Wrapper>
        <Title>View Remarks Details</Title>
        {/* Display Remarks */}
        <RemarksWrapper>
          {selectedItem?.remarks?.length > 0 ? (
            selectedItem.remarks.map((remark, index) => (
              <RemarkCard key={index}>
                <Header>
                  <UserType>
                    <IconWrapper>
                      <UserIcon />
                    </IconWrapper>
                    <span> </span>
                    {userTypeLabels[remark.userType] || "Unknown"}
                  </UserType>
                </Header>
                <Content>{remark.remark}</Content>
                <Footer>
                  <DateIcon />
                  <RemarkDate>
                    Remarked Date:{" "}
                    {moment(remark.remarkedAt).format("DD-MM-YYYY hh:mm A")}
                  </RemarkDate>
                </Footer>
              </RemarkCard>
            ))
          ) : (
            <NoRemarks>No remarks available.</NoRemarks>
          )}
        </RemarksWrapper>
      </Wrapper>
      <BtnWrapper>
        <CancelBtn onClick={() => setOpenViewRemarksModel(false)}>
          Close
        </CancelBtn>
      </BtnWrapper>
    </Model>
  );
};

// const Wrapper = tw.div`px-6 py-4`;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;

const RemarksWrapper = tw.div`mt-6 space-y-6`;

const RemarkCard = tw.div`bg-white border border-gray-200 shadow-sm rounded-lg p-4`;
const Header = tw.div`flex items-center justify-between mb-4`;
const UserType = tw.p`text-sm text-gray-700 font-medium flex items-center space-x-2`;
const Content = tw.p`text-gray-800 text-sm leading-relaxed`;
const Footer = tw.div`flex items-center mt-4 space-x-2 text-gray-500 text-xs`;

const IconWrapper = tw.span`bg-blue-100 text-blue-500 rounded-full p-1 flex items-center justify-center`;
const UserIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14c-4.418 0-8 1.79-8 4v2h16v-2c0-2.21-3.582-4-8-4z"
    />
  </svg>
);

const DateIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-4 w-4 text-gray-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7V3m8 4V3m-9 8h10m-9 4h10m-9 4h10m-9-8v10m2-12H7m8 0h1m-2 12h-1m-2-12h1"
    />
  </svg>
);

const RemarkDate = tw.p`text-xs text-gray-500`;

const NoRemarks = tw.p`text-gray-500 italic text-sm`;

const BtnWrapper = tw.div`w-full flex items-center justify-end space-x-4 mt-6`;

export default ViewRemarksModel;
